import { Component, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { INPUT_TYPES_MAP } from '@constants/input-types-map';
import { IErrorForm } from '@shared/form-wrapper/interfaces';

@Component({
  selector: 'organization-contact-information-form',
  templateUrl: './organization-contact-information-form.component.html',
  styleUrls: ['./organization-contact-information-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationContactInformationFormComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;
  public contactInformationFormGroup: FormGroup;
  public integerInputMap = INPUT_TYPES_MAP.INTEGER;
  public errors: { [name: string]: IErrorForm } = {
    businessEmail: {
      required: 'FORM_ERROR.REQUIRED',
      pattern: 'FORM_ERROR.LOGIN_EMAIL',
      invalidEmail: 'YOU_ENTERED_INVALID_EMAIL',
    },
    businessPhone: {
      maxlength: 'FORM_ERROR.MAX_LENGTH',
      validatePhoneNumber: 'FORM_ERROR.PHONE_NUMBER',
    },
  };

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.contactInformationFormGroup = this.formGroup?.get('contactInformation') as FormGroup;
    this.contactInformationFormGroup.statusChanges.subscribe((status) => {
      if (status === 'INVALID') {
        this.cdr.markForCheck();
      }
    });
  }
}
